import type { WorkingFacilityCountsPayload } from '@Application/Indicators/WorkingFacility/Actions/workingFacilityCountsFetched';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class WorkingFacilityCountsView {
	readonly facilityId: number;
	readonly watchedRuns: number | null;

	constructor(payload: WorkingFacilityCountsPayload) {
		this.facilityId = payload.facilityId;
		this.watchedRuns = payload.watchedRuns;

		Object.freeze(this);
	}
}

export default WorkingFacilityCountsView;
